import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import { initializeThemePreference } from "./utils/theme";
import { initializeLanguagePreference } from "./utils/language";

const container = document.getElementById("root");
const root = createRoot(container);

initializeThemePreference();
initializeLanguagePreference();

root.render(<App />);
